const CATEGORY_ROUTES = {
  GET_CATEGORY: 'categories/list',
  ADD_CATEGORY: 'categories/add',
  GET_SUBCATEGORY: 'subcategories/list',
  ADD_SUBCATEGORY: 'subcategories/add',
};

export default CATEGORY_ROUTES;
